// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"activities-list__wrap--2v2W-"};